import script from "./goRinSyo0009.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0009.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0009.vue?vue&type=style&index=0&id=6ed574c2&lang=scss"

const __exports__ = script;

export default __exports__